// src/pages/profile/profile_componnent_edit/EditName.jsx
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import {
  Stack,
  TextField,
} from "@mui/material";
import CustomButton from "../../../Components/CustomButton";

export default function EditName({
  initialNom,
  initialPrenom,
  onCancel,
  onSubmit,
}) {
  const [nom, setNom] = useState(initialNom || "");
  const [prenom, setPrenom] = useState(initialPrenom || "");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNom(initialNom || "");
    setPrenom(initialPrenom || "");
  }, [initialNom, initialPrenom]);

  const handleSave = async () => {
    if (!nom.trim() || !prenom.trim()) {
      setError(true);
      return;
    }
    setError(false);
    setLoading(true);
    try {
      await onSubmit({ nom: nom.trim(), prenom: prenom.trim() });
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  return (
    <Stack spacing={2}>
      <Typography>Modification du nom</Typography>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        <TextField
          fullWidth
          placeholder="Nom"
          label="Nom"
          value={nom}
          onChange={(e) => setNom(e.target.value)}
          error={error && !nom.trim()}
          helperText={error && !nom.trim() ? "Le nom est obligatoire" : ""}
        />
        <TextField
          fullWidth
          placeholder="Prénoms"
          label="Prénoms"
          value={prenom}
          onChange={(e) => setPrenom(e.target.value)}
          error={error && !prenom.trim()}
          helperText={error && !prenom.trim() ? "Le prénom est obligatoire" : ""}
        />
      </Stack>
      <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
        <CustomButton
          type={"secondaire"}
          buttonText={"Annuler"}
          onClick={onCancel}
        />
        <CustomButton
          loading={loading}
          buttonText={"Enregistrer"}
          onClick={handleSave}
        />
      </Stack>
    </Stack>
  );
}

EditName.propTypes = {
  initialNom: PropTypes.string,
  initialPrenom: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
